import { render, staticRenderFns } from "./MaterialsInfo.vue?vue&type=template&id=68e7065a&scoped=true"
import script from "./MaterialsInfo.vue?vue&type=script&lang=js"
export * from "./MaterialsInfo.vue?vue&type=script&lang=js"
import style0 from "./MaterialsInfo.vue?vue&type=style&index=0&id=68e7065a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7065a",
  null
  
)

export default component.exports